export enum FormType {
    REGISTRAR = 1,
    EDITAR = 2,
    CONSULTAR = 3,
    BUSCAR = 4,
    REVISAR = 5
}


export enum GridType {
    SERVER = 'server',
    LIST = 'list'
}